module.exports = __webpack_public_path__ + "img/Dash_mini_map.bf3e15e5.svg";